import axios from '.././Utils/Utility/axiosconfig'
import isAuthenticate from '.././Utils/Utility/auth'

export const auctionMessageAction = (list) => ({
    type: 'AUCTIONMSG',
    list,
})

const auctionMsgDetails = (body) => {
    return async (dispatch) => {
        try {
            const res = await axios.post('api/auctionmsg', body)
            if (res.data.status === 'success') {
                dispatch(auctionMessageAction(res.data.response))
            } else {
                return `something went wrong`
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export default auctionMsgDetails
